import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const userConsentResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const consents = await API.getUserConsents();
        const res = consents.data.data.find((el) => el.id == to.params.id);
        if(res === null && res === undefined) throw Error(`undefined consent with id: ${to.params.id}`);                           
        to.meta.consent = res;
    } catch (error) {
        console.error('CONSENT_RESOLVER_ERROR');
        return { name: 'Consents' };
    }
}